export enum Theme {
  GOLD_LIGHT = 'gold-light',
  GOLD_DARK = 'gold-dark',
  BLUE_LIGHT = 'blue-light',
  BLUE_DARK = 'blue-dark',
}

export enum ThemeName {
  GOLD = 'gold',
  BLUE = 'blue',
}

export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark',
}
